import {
  STORE_USER_DETAILS,
  TOGGLE_FORGOT_PASSWORD_MODE,
  TOGGLE_USER_LOADER,
  UPDATE_GUEST_USER_INFO,
  STORE_USER_INFO,
  AUTHENTICATE_USER,
  CLEAR_USER_DATA,
  TOGGLE_GUEST_USER_SIGNUP_LOADER,
  TOGGLE_COMPLETE_FLOW_LOADER,
  TOGGLE_USER_AGREEMENT_MODAL,
  SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER,
  SHOW_SKELETON_REPORT_LOADER,
} from 'redux/actions/actionTypes';
const initialState = {
  userId: '',
  profileId: '',
  name: '',
  gender: '',
  age: '',
  phone: '',
  otp: '',
  isUserAuthenticated: false,
  showGuestUserSignupLoader: false,
  showCompleteFlowLoader: false,
  isGuestUser: false,
  isUserLogInDone: false,
  forgotPasswordMode: false,
  showUserLoader: false,
  showUserAgreementPopup: false,
  showSignUpAndProcessCaseLoader: false,
  showSkeletonReportLoader: false,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case STORE_USER_DETAILS: {
      return { ...state, ...payload };
    }
    case TOGGLE_FORGOT_PASSWORD_MODE: {
      return {
        ...state,
        forgotPasswordMode: payload.forgotPasswordMode,
      };
    }
    case TOGGLE_USER_LOADER: {
      return {
        ...state,
        showUserLoader: payload.showUserLoader,
      };
    }
    case AUTHENTICATE_USER: {
      return {
        ...state,
        isUserAuthenticated: payload.isUserAuthenticated,
      };
    }
    case STORE_USER_INFO: {
      return {
        ...state,
        ...payload,
      };
    }
    case UPDATE_GUEST_USER_INFO: {
      const { path, value } = payload;
      return {
        ...state,
        guestUser: {
          ...state.guestUser,
          [path]: value,
        },
      };
    }
    case CLEAR_USER_DATA: {
      return {
        ...initialState,
      };
    }
    case TOGGLE_GUEST_USER_SIGNUP_LOADER: {
      return {
        ...state,
        showGuestUserSignupLoader: payload,
      };
    }
    case TOGGLE_COMPLETE_FLOW_LOADER: {
      return {
        ...state,
        showCompleteFlowLoader: payload,
      };
    }
    case TOGGLE_USER_AGREEMENT_MODAL: {
      return {
        ...state,
        showUserAgreementPopup: payload,
      };
    }
    case SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER: {
      return {
        ...state,
        showSignUpAndProcessCaseLoader: payload,
      };
    }
    case SHOW_SKELETON_REPORT_LOADER: {
      return {
        ...state,
        showSkeletonReportLoader: payload,
      };
    }
    default:
      return state;
  }
};
